import React, { useContext, useEffect, useRef, useState } from "react";
import "../styles/login.css";
import Form from "react-bootstrap/Form";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import axios from "../../api/axios";
import useAuth from ".././logincomponent/subcomponent/hooks/useAuth";
import { GlobalContext } from "../../context/GlobalContext";
import img1 from "../../Images/logo.webp";
import { Eye, EyeSlash } from "react-bootstrap-icons";

const cookies = new Cookies();

// Validation patterns
const PASSWORD_REGEX = /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,}$/;

const ImpersonateLogin = () => {
  const [showPassword, setShowPassword] = useState(false);
  const { dispatch } = useContext(GlobalContext);
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const emailRef = useRef();
  const errRef = useRef();

  const [formData, setFormData] = useState({
    email: "",
    impersonateEmail: "",
    password: "",
  });

  const [errMsg, setErrMsg] = useState("");
  const [validated, setValidated] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    emailRef.current?.focus();
  }, []);

  const handleChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const removeAddressComponentsFromLocalstorage = () => {
    [
      "homeComponentsMazo",
      "companyComponentsMazo",
      "secondOwnerHomeComponentsMazo",
      "residentialComponentsMazo",
      "mailingComponentsMazo",
      "employerComponentsMazo",
      "coApplicantEmployerComponentsMazo",
      "coApplicantResidentialComponentsMazo",
    ].forEach((key) => localStorage.removeItem(key));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (!form.checkValidity() || !PASSWORD_REGEX.test(formData.password)) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    setShowLoader(true);
    try {
      const { email, password, impersonateEmail } = formData;
      const response = await axios.post("/auth/impersonate/", {
        email,
        password,
        impersonate_email: impersonateEmail,
      });

      if (response?.status === 200) {
        const { access, refresh } = response?.data?.data;

        localStorage.setItem("profile-email", email);
        localStorage.setItem("isLoggedIn", "true");
        cookies.set("access", access);
        cookies.set("refresh", refresh);

        setAuth({ email, password, access });
        dispatch({ type: "IS_LOGGED_IN", payload: true });

        removeAddressComponentsFromLocalstorage();
        navigate("/", { replace: true });
      }
    } catch (err) {
      setErrMsg(
        err.response?.data?.detail ||
          (err.response?.status === 400 && "Missing email or password") ||
          (err.response?.status === 404 &&
            "Impersonate email is incorrect. User not found.") ||
          (err.response?.status === 401 && "Email or password incorrect") ||
          "Login Failed"
      );
    } finally {
      setShowLoader(false);
      setValidated(true);
    }
  };

  const { email, password, impersonateEmail } = formData;

  useEffect(() => {
    if(PASSWORD_REGEX.test(password)){
      setValidated(false);
    }
  }, [password]);

  return (
    <div className="container main-square-box login-page">
      <div className="row main-square-box-h-login d-flex justify-content-center">
        <div className="col-lg-10 color shadow p-3 rounded-4">
          {errMsg && (
            <div className="alert alert-danger alert-dismissible fade show mt-3">
              <p ref={errRef} aria-live="assertive">
                {errMsg}
              </p>
              <button
                type="button"
                className="btn-close"
                onClick={() => setErrMsg("")}
              ></button>
            </div>
          )}

          <div className="centered-div mb-4">
            <div className="form-div">
              <div className="Icon-div">
                <img src={img1} className="w-100" alt="logo" />
              </div>

              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                {/* Email */}
                <Form.Group className="mb-3" controlId="loginEmail">
                  <Form.Label>Email:</Form.Label>
                  <Form.Control
                    type="email"
                    ref={emailRef}
                    autoComplete="off"
                    placeholder="name@example.com"
                    value={email}
                    onChange={handleChange("email")}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {validated && !email
                      ? "Email is required"
                      : "Please provide a valid email."}
                  </Form.Control.Feedback>
                </Form.Group>

                {/* Password */}
                <Form.Group
                  className="mb-3 position-relative"
                  controlId="loginPassword"
                >
                  <Form.Label>Password:</Form.Label>
                  <div className="position-relative">
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      value={password}
                      onChange={handleChange("password")}
                      required
                      isInvalid={validated && !PASSWORD_REGEX.test(password)}
                    />
                    {!validated && (
                      <span
                        className="position-absolute end-0 top-50 translate-middle-y"
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowPassword((prev) => !prev)}
                      >
                        <div className="me-2">
                          {showPassword ? (
                            <EyeSlash size={20} />
                          ) : (
                            <Eye size={20} />
                          )}
                        </div>
                      </span>
                    )}
                    <Form.Control.Feedback type="invalid">
                      {!password
                        ? "Password is required"
                        : "Password must be at least 8 characters long and contain both letters and numbers."}
                    </Form.Control.Feedback>
                  </div>
                </Form.Group>

                {/* Impersonate Email */}
                <Form.Group className="mb-3" controlId="impersonateEmail">
                  <Form.Label>Impersonate Email:</Form.Label>
                  <Form.Control
                    type="email"
                    autoComplete="off"
                    placeholder="name@example.com"
                    value={impersonateEmail}
                    onChange={handleChange("impersonateEmail")}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {validated && !impersonateEmail
                      ? "Impersonate email is required"
                      : "Please provide a valid email."}
                  </Form.Control.Feedback>
                </Form.Group>

                <button
                  id="btn-radiuss"
                  type="submit"
                  className="btn btn-primary mt-2"
                >
                  {showLoader ? (
                    <Spinner animation="border" size="sm" role="status" />
                  ) : (
                    "Log In"
                  )}
                </button>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImpersonateLogin;
